// The open waybill lives in `?awb=`, the way the container screen lives in `?id=`.

/** A waybill written with or without its dash, as `176-12345675`; null when it is not eleven digits. */
export function canonicalAwb(raw: string | null | undefined): string | null {
  const digits = (raw ?? '').replace(/\D/g, '')
  return digits.length === 11 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : null
}

/** The waybill `?awb=` names, or null. */
export function screenAwbOf(search: string): string | null {
  return canonicalAwb(new URLSearchParams(search).get('awb'))
}

/** The address with this waybill open, every other parameter kept. */
export function withAwb(search: string, awb: string): string {
  const params = new URLSearchParams(search)
  params.set('awb', awb)
  return `?${params}`
}

/** The address with no waybill open, every other parameter kept. */
export function withoutAwb(search: string): string {
  const params = new URLSearchParams(search)
  params.delete('awb')
  const rest = params.toString()
  return rest ? `?${rest}` : ''
}

/**
 * How the screen closes: Back when the board opened it (the board is the entry behind it), otherwise the
 * address loses `awb` in place — a shared link or a fresh tab has no board behind it to go back to.
 */
export function closeBy(openedHere: boolean): 'back' | 'replace' {
  return openedHere ? 'back' : 'replace'
}
